
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export const useCouponBookingHistory = (userCouponId?: string) => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['coupon-booking-history', userCouponId, user?.id],
    queryFn: async () => {
      if (!user || !userCouponId) return [];

      console.log('useCouponBookingHistory - Fetching booking history for userCouponId:', userCouponId);

      // First get the booking_coupons for this user_coupon
      const { data: bookingCoupons, error: bookingCouponsError } = await supabase
        .from('booking_coupons')
        .select('booking_id, created_at, discount_amount')
        .eq('user_coupon_id', userCouponId)
        .order('created_at', { ascending: false });

      if (bookingCouponsError) {
        console.error('Error fetching booking coupons:', bookingCouponsError);
        throw bookingCouponsError;
      }

      if (!bookingCoupons || bookingCoupons.length === 0) {
        console.log('useCouponBookingHistory - No booking coupons found');
        return [];
      }

      // Then get the booking details for these booking IDs
      const bookingIds = bookingCoupons.map(bc => bc.booking_id);
      
      const { data: bookings, error: bookingsError } = await supabase
        .from('bookings')
        .select('id, booking_date, status, created_at')
        .in('id', bookingIds);

      if (bookingsError) {
        console.error('Error fetching bookings:', bookingsError);
        throw bookingsError;
      }

      // Combine the data
      const result = bookingCoupons.map(bc => ({
        ...bc,
        booking: bookings?.find(b => b.id === bc.booking_id) || null
      }));

      console.log('useCouponBookingHistory - Booking history:', result);

      return result;
    },
    enabled: !!user && !!userCouponId,
  });
};
